module.exports = __webpack_public_path__ + "img/delete_icon.bbcbb965.png";